import React from 'react';

/* eslint-disable react/jsx-no-comment-textnodes */
export const TestHarness = (): JSX.Element => (
    <div className="m-8">
        <h1>Test Harness</h1>
        <code>// insert content here</code>
    </div>
);
